import { atom, useAtom } from 'jotai';
import { CURRENCY_MAP } from '../constants';
import { AccountDataStatus } from '../types/dataStatus';

export type CurrencyCode = keyof typeof CURRENCY_MAP;

export type CurrentClient = {
  all_combinations: [string, string][];
  cleared_options: string[];
  platforms: string; // "0, 3, 1, 2, 4"
  current_client: string; // "American Girl - US",
  current_client_market: string;
  current_client_status: 'Active' | 'HistoricalAccess';
  current_client_currency_code: CurrencyCode;
  // OSM-1983 — false when the current account's BQ dataset is missing
  // or a required table/view inside it failed to load. Optional for
  // backwards compatibility with cached/pre-fix payloads.
  current_client_data_available?: boolean;
  // OSM-1983 — *why* it's unavailable, so the UI can say "account not present"
  // (permanent) rather than "temporarily unavailable" (transient) and only
  // offer Retry when retrying could actually help.
  current_client_data_status?: AccountDataStatus;
};

const DEFAULT_CLIENT: CurrentClient = {
  current_client: '',
  all_combinations: [],
  cleared_options: [],
  platforms: '',
  current_client_market: '',
  current_client_status: 'Active',
  current_client_currency_code: 'USD',
  current_client_data_available: true,
};

const currentClientAtom = atom(DEFAULT_CLIENT);

export const useCurrentClientAtom = () => useAtom(currentClientAtom);
